import { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MsalInterceptor } from "@azure/msal-angular";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';

@Injectable()
export class MsalConditionalInterceptor extends MsalInterceptor {
  override intercept(req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
      if ((!req.url.startsWith(environment.apiServerUrl) && req.url.startsWith('htt')) || req.url.endsWith(environment.azureLoginApi.subUri)) {
        return super.intercept(req, next);
      }
      return next.handle(req);
    }
}